import React from "react";
import { useEffect, useRef,useState,useContext } from "react";
import { useLocation } from "react-router-dom";
import Header from "../pages/inc/Header";
//import Header from "../pages/inc/Headerbackup";
import Footer from "../pages/inc/Footer";
import Banner from "./Home/Banner";
import Body from "./Home/Body";
import Popmodal from "../pages/inc/popmodal";
import { button } from "framer-motion/client";
//import Testkey from "./Testkey";
import { useTranslation } from 'react-i18next';
import { useNavigate } from "react-router-dom";



const Home = () => {
  const API_KEY = '9f262563611a4f659dd9177ce4206e8a'; 
    const navigate = useNavigate();
    if(localStorage.getItem('local_country_iso_code') == null){

 
    fetch(`https://api.ipgeolocation.io/ipgeo?apiKey=${API_KEY}`)
      .then(response => response.json())
      .then(data => {
            localStorage.setItem('local_country_iso_code',data.country_code2);
        localStorage.setItem('local_country_languages',data.languages);
         // navigate(0);
         window.location.reload();
        //window.location.replace(window.location.href);
      //  setLocationData(data);
      })
      .catch(error => {
        console.error('Error fetching IP geolocation:', error);
      });
}
  const [location_p, setLocation] = useState(null);

const { t, i18n } = useTranslation()
    const sectionSessionRef = useRef(null);
    const location = useLocation();

    useEffect(() => {
      if (location.hash === "#upcoming_section" && sectionSessionRef.current) {
        sectionSessionRef.current.scrollIntoView({ behavior: "smooth" });
         setTimeout(() => {document.body.removeAttribute("style");},1000)
      }
    }, [location]);
    const sectionSession = () => {
   
    sectionSessionRef.current.scrollIntoView({ behavior: 'smooth' });
     setTimeout(() => {document.body.removeAttribute("style");},1000)
  };
  const banner = {
    title: t('banner_heading'),
    logo:"img/one2one-new-logo_.png",
    img:["img/banner_img_one.jpg","img/banner_img_two.jpg","img/banner_img_three.jpg","img/banner_img_four.jpg","img/banner_img_five.jpg"]
  };

  const hellosection = {
    img:"img/hello-daniel.png",
    textone:t("A_Word_from_Evangelist"),
    texttwo:"Daniel Kolenda"
  };
 
  const whatsection = {
    img:"img/cfan-summary-image.jpg",
    textone:t('whatsection'),
   };

  const winningdata = {
    img:"img/cfn-banner-logo.svg",
    textone:t('winningdata'),
    button:{link:"#",text:"Register"}
  }; 
  let numberWithCommas;
    if(localStorage.getItem('homePageCount') == null){
   
       numberWithCommas = 100799127;
    }else{
       numberWithCommas = localStorage.getItem('homePageCount');
      numberWithCommas = parseInt(numberWithCommas);
    }
  const gallerydata = {
    img_tops:["img/tp-gallery-two.jpg","img/tp-gallery-one.jpg","img/tp-gallery-three.jpg"],
    img_middels:["img/galler-one.jpg"],
    img_bottoms:["img/bottom-galley-one.jpg","img/bottom-gallery-two.jpg","img/bottom-gallery-three.jpg","img/bottom-gallery-four.jpg"],
    text_middels:{one:numberWithCommas,two:t("Documented_Decisions_for_Christ_and_Counting")}

  }

  const setpapplydata = {
      title: t('Steps_to_Apply'),
      steps: [{title:t('setpapplydata_0'),serial_number:"1"},
        {title:t('setpapplydata_1'),serial_number:"2"},
        {title:t('setpapplydata_2'),serial_number:"3"},
        {title:t('setpapplydata_3'),serial_number:"4"},
      ],
      img:"img/cfan_apply_data.jpg"
  };

  const registrtion_setp_info = 
    [{title:t("what_does_the_ONE2ONE_program_look_like"),descrtion:t('what_does_the_ONE2ONE_program_look_like_description'),lists:[t("video_teaching_ko"), t("what_evng_matter"), t("cfan_abc_think"), t("how_write_share"), t("practical_tools"), t("activation_and_encouragement")],type:true},
      {title:t("who_can_apply"),descrtion:t('who_can_apply_description'),lists:[t("regist_list_st_one"), t("regist_list_st_two"), t("regist_list_st_three")],type:false},
      {title:t("who_will_teach"),descrtion:t('who_will_teach_description'),lists:[],type:true},
      {title:t("how_can_I_Register"),descrtion:t('how_can_I_Register_description'),lists:[],type:true},
      {title:t("traning_near_me"),descrtion:t('traning_near_me_description'),lists:[],type:true}
    ];

  return (
    <>
    <div className="loader d-none" id="loder-tive">
	<div className="loader-content">
		<div id="loader-animation"></div>
	</div>
</div>
    <Header sectionSession={sectionSession} location_p={location_p} />

    <Banner banner={banner} />
    <Body hellosection={hellosection} sectionSessionRef={sectionSessionRef} whatsection={whatsection} winningdata={winningdata} gallerydata={gallerydata} setpapplydata={setpapplydata} registrtion_setp_info={registrtion_setp_info} />
    <Footer sectionSession={sectionSession}/>
    <Popmodal/>
    </>
  );
};

export default Home;